import { Stack, type StackProps } from '@chakra-ui/react'

import type * as url from '@/client/services/url'

import FAQBody from './FAQBody'
import FAQHeader from './FAQHeader'
import type { FaqItem } from './types'

export default function FAQ({
  items,
  category,
  headerText = 'Frequently Asked Questions',
  collapsible = false,
  mt,
  mb,
  justifyHeader = 'center',
}: {
  items: FaqItem[]
  category?: url.faq.Category
  headerText?: string
  collapsible?: boolean
  mt?: StackProps['mt']
  mb?: StackProps['mb']
  justifyHeader?: StackProps['justifyContent']
}): JSX.Element {
  return (
    <Stack direction="column" spacing={8} mt={mt} mb={mb}>
      <FAQHeader category={category} headerText={headerText} justifyHeader={justifyHeader} />
      <FAQBody items={items} collapsible={collapsible} />
    </Stack>
  )
}
